import request from 'sb-request'
import constants from 'common/helpers/constants'
import actions from 'redux/actions'


const acceptCard = (body) =>
  request.post('rest/gift/card/accept', {
    body,
  })
    .then(
      ({ token }) => {
        actions.models.requestTokens.update({
          [constants.requestTokens.giftCard]: token,
        })
      },
      ({ message, resData: { token } }) => {
        if (token) {
          actions.models.requestTokens.update({
            [constants.requestTokens.giftCard]: token,
          })
        }

        return Promise.reject(message || 'Wrong gift card code!')
      })

const registerAndAcceptCard = (body) =>
  request.post('rest/gift/card/register-and-accept', {
    body,
    formData: true,
  })
    .then(
      ({ token, message }) => {
        actions.models.requestTokens.update({
          [constants.requestTokens.giftCard]: token,
        })

        return message
      },
      ({ message, resData: { token } }) => {
        if (token) {
          actions.models.requestTokens.update({
            [constants.requestTokens.giftCard]: token,
          })
        }

        return Promise.reject(message || 'Wrong gift card code!')
      }
    )


export default {
  acceptCard,
  registerAndAcceptCard,
}
